<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { qryH5RegInfo } from "@/api/login";
import store from '@/utils/store'
export default {
  name: 'App',

  activated(){
    
  },
  created() {
    qryH5RegInfo({reCommUid:''}).then(res => {
      if(res.code == 200) {
        const data = JSON.parse(res.data);
        const downloadUrl = data.downUrl;
        this.$store.dispatch('setCache', { key: 'downloadUrl', value: downloadUrl });
        console.log(this.$store.getters.getCache('downloadUrl'))
      }
    });
  },
  methods: {
  }

}
window.onload = function () {
  // 禁用双指放大
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  // 禁用双击放大
  let lastTouchEnd = 0
  document.addEventListener(
    'touchend',
    function (event) {
      const now = new Date().getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
</script>

<style>
#app {
  /* font-family: Baskerville Old Face,微軟正黑體; */
  /* font-family: Baskerville Old Face; */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  color: #2c3e50;

}
</style>
